import { Container, List, ListItem, ListItemText, Typography } from '@material-ui/core';
import axios from 'axios';
import { React, useEffect, useState } from 'react';
import { StyledBox, StyledFreeTips, StyledHeading, StyledParagraph } from '../styles/global-style';
import Guru from './components/guru';
import Multibets from './components/multibets';
import Results from './components/results';
import useStyles from './styles';
import * as API from '../../api/index';
import PopularGames from './components/popular';



const Home = () => {
    const [games, setGames] = useState([]);
    const [results, setResults] = useState([]);
    const [user, setUser] = useState(JSON.parse(localStorage.getItem('profile')))
    const [subscribed, setSubscribed] = useState(false);

    

    const fetchData = async () => {
        const getGames = API.fetchTips();
        console.log(getGames);
        const getResults = API.fetchResults();

        await axios.all([getGames, getResults]).then(
            axios.spread((...allData) => {
                const allGames = allData[0].data
                const allResults = allData[1].data

                setGames(allGames);
                setResults(allResults);
            })
        ).catch((errors) =>
        console.log(errors)
        )
        
    }

    const getUser = async () => {
        try {
            const username = user?.user.username
            const { data } = await API.guruSubscribers(username)
            setSubscribed(data[0].guru)

        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        fetchData();
        getUser();
        document.title = 'Tips Predictions | Sure Tips'
    }, [])

    const classes = useStyles();


    return (
        <Container align="center" >
            <StyledBox align='justify'>
                <StyledParagraph variant='caption'>
                    Tips-predictions is the leading <b>sure tips</b> provider preferred by lots of soccer punters
                    as the core source of football sure betting tips including correct scores, Fixed Matches, VIP tips and jackpots. The use of advanced AI in data analysis algorithms
                    is the foremost reason behind our success in providing these <b>Correct predictions</b>. Book predictions 
                    of your choice now to win big today.
                </StyledParagraph>
            </StyledBox>
            <StyledFreeTips align="center">
                <StyledHeading variant='h5'>
                    Tips-Predictions Free tips today
                </StyledHeading>
                <List mb={10} className={classes.list}>
                    {games.map((free) =>
                        free.category === 'FR' && (
                            <>
                                {free.games.map((game) =>
                                    <ListItem key={game.FIELD1} className={classes.listItems}>
                                        <ListItemText>
                                            <Typography variant='body2'>
                                                {game.FIELD1}.  {game.Time}, {game.Date} - <b>{game.Match}</b>, <u>tips:</u> <b>{game.Prediction}</b> 
                                            </Typography>
                                        </ListItemText>
                                    </ListItem>
                                )}
                            </>
                        )

                    )}
                </List>
            </StyledFreeTips>

            <Guru subscribed={subscribed} games={games} />
            <PopularGames/>
            <Multibets />
            <Results results={results} />
        </Container>
    );
};

export default Home;